import {Event, Channel} from "@unibuddy/sockets";

const conversationChannel = new Channel("", {private: true});
export const chatMessageEvent = new Event("ChatMessage", conversationChannel);

const applicantInfoChannel = new Channel("applicant-info-group");
export const delinkApplicantEvent = new Event("applicant-delinked", applicantInfoChannel);

const chatServiceConversationChannel = new Channel("conversation", {private: true});
export const sendMessageEvent = new Event("send-message", chatServiceConversationChannel);
